module.exports = __webpack_public_path__ + "static/media/t_hu.c8b89299.pdf";